import { createSelector } from 'reselect';

const queueSelector = state => state.messageSystem.modals.queue;
export const currentModalSelector = state => state.messageSystem.modals.currentModal;

const getCurrentModal = (queue, currentModal) => {
  return queue.find(({ id }) => id === currentModal) || {};
};

export default createSelector(
  queueSelector,
  currentModalSelector,
  getCurrentModal,
);
